module.exports = false;



//////////////////
// WEBPACK FOOTER
// /mnt/e/apps/architect3/client/node_modules/core-js/modules/_library.js
// module id = KGrn
// module chunks = polyfills